import React from "react";

const TokenExchangeRate = ({
	usdt,
	selectedTokenOneName,
	selectedTokenTwoName,
	isFirstInTheRow = false,
}) => {
	const setTokenQue = () => {
		if (isFirstInTheRow) {
			return `${selectedTokenTwoName} per ${selectedTokenOneName}`;
		}
		return `${selectedTokenOneName} per ${selectedTokenTwoName}`;
	};

	return (
		<div className="flex border border-lightBlue dark:border-darkButBg flex-col items-center justify-center gap-3 py-4 w-full rounded-lg">
			<p
				className={
					"text-black dark:text-white font-semibold text-2xl leading-6"
				}
			>
				{usdt}
			</p>
			<p
				className={
					"text-semiBlack dark:text-semiWhite leading-4 text-sm tracking-[0.15px]"
				}
			>
				{setTokenQue()}
			</p>
		</div>
	);
};

export default TokenExchangeRate;
